import { location, onMount } from 'cdui-js';
import i18n from '../../../i18n';
import { CurrencyFlag } from '../../../components/CurrencyFlag';
import arrowRight from '../../../assets/deposit-records/arrow-right.svg';
import { goBackByBrowser } from '../../../lib/browser';
import { StockTransferNav } from './Nav';
import { syncStockTransferAppShell, withStockTransferQuery } from './shared';
import './page.css';

export const StockTransferInHome = () => {
  onMount(() => {
    syncStockTransferAppShell();
  });

  const goSelectBroker = (market: 'HK' | 'US') => {
    location.routeTo(withStockTransferQuery('/h5/stock-transfer-in/select-broker', { market }), [0, 0]);
  };

  return (
    <div class="stock-transfer-in-h5">
      <StockTransferNav title={i18n.StockTransferIn.Title} onBack={goBackByBrowser} />
      <div class="sti-scroll">
        <div class="sti-section">{i18n.StockTransferIn.SelectMarket}</div>
        <div class="sti-tip sti-tip-warn">
          <span>{i18n.StockTransferIn.MultiMarketTip}</span>
        </div>
        <div class="sti-card" onclick={() => goSelectBroker('HK')}>
          <CurrencyFlag code="HKD" class="sti-flag" />
          <span class="sti-card-label">{i18n.StockTransferIn.TransferHk}</span>
          <img class="sti-card-arrow" src={arrowRight} alt="" />
        </div>
        <div class="sti-card" onclick={() => goSelectBroker('US')}>
          <CurrencyFlag code="USD" class="sti-flag" />
          <span class="sti-card-label">{i18n.StockTransferIn.TransferUs}</span>
          <img class="sti-card-arrow" src={arrowRight} alt="" />
        </div>
      </div>
    </div>
  );
};
